"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = __importDefault(require("qs"));
const lodash_1 = __importDefault(require("lodash"));
const Errors_1 = require("../Errors");
const prefix = `/api/admin/ac/v2/adminTool`;
const oauthAdminToolPrefix = `/api/admin/auth/adminTool`;
const API = {
    // Marketplace
    listMarketplace: `${prefix}/marketplace/published/list`,
    detailMarketplace: `${prefix}/marketplace/published/detail`,
    updateMarketplace: `${prefix}/marketplace/published/update`,
    // Notification
    listNews: `${prefix}/notification/published/list`,
    createNews: `${prefix}/notification/published/create`,
    updateNews: `${prefix}/notification/published/update`,
    // Service Certificates
    listCertificates: `${prefix}/serviceCertificate/published/list`,
    updateCertificateDisplayOrder: `${prefix}/serviceCertificate/published/updateDisplayOrder`,
    // Identity Field
    listIdentity: `${prefix}/identity/published/list`,
    createIdentity: `${prefix}/identity/published/create`,
    updateIdentity: `${prefix}/identity/published/update`,
    // Group Identity Field
    listGroupIdentity: `${prefix}/groupIdentity/published/list`,
    createGroupIdentity: `${prefix}/groupIdentity/published/create`,
    updateGroupIdentity: `${prefix}/groupIdentity/published/update`,
    // Runtime Config
    listRuntimeConfig: `${prefix}/runtimeConfig/published/list`,
    detailRuntimeConfig: `${prefix}/runtimeConfig/published/detail`,
    createRuntimeConfig: `${prefix}/runtimeConfig/published/create`,
    updateRuntimeConfig: `${prefix}/runtimeConfig/published/update`,
    // User debugger
    userDetail: `${prefix}/debugger/published/userDetail`,
    treeHistory: `${prefix}/debugger/published/treeHistory`,
    serviceRegistered: `${prefix}/debugger/published/serviceRegistered`,
    registerLog: `${prefix}/debugger/published/registerLog`,
    submitLog: `${prefix}/debugger/published/submitLog`,
    userCertificate: `${prefix}/debugger/published/userCertificate`,
    // Delete identity
    deleteIdentity: `${prefix}/deleteIdentity/published/delete`,
    deleteBulkIdentity: `${prefix}/deleteIdentity/published/deleteBulk`,
    listIdentityDeleted: `${prefix}/deleteIdentity/published/list`,
    listJobDeleteIdentity: `${prefix}/deleteIdentity/published/listJob`,
    recoverIdentity: `${prefix}/deleteIdentity/published/recoverIdentity`,
    deleteRecoverBin: `${prefix}/deleteIdentity/published/deleteRecoverBin`,
    // Billing stats
    listBillingStats: `${prefix}/billingStats/published/list`,
    generateReport: `${prefix}/billingStats/published/report`,
    // Billing logs
    billingServiceLogs: `${prefix}/billingStats/published/logs`,
    // Service Link [Deprecated]
    getListServiceLink: `${prefix}/serviceLink/published/list`,
    getServiceLinkInfo: `${prefix}/serviceLink/published/info`,
    createServiceLink: `${prefix}/serviceLink/published/create`,
    updateServiceLink: `${prefix}/serviceLink/published/update`,
    removeServiceLink: `${prefix}/serviceLink/published/remove`,
    // Verify-With Config
    canUseClientIdToLink: `${prefix}/verifyWithConfig/published/clientId/check`,
    getListVerifyWithConfigs: `${prefix}/verifyWithConfig/published/list`,
    getVerifyWithConfigInfo: `${prefix}/verifyWithConfig/published/info`,
    createVerifyWithConfig: `${prefix}/verifyWithConfig/published/create`,
    updateVerifyWithConfig: `${prefix}/verifyWithConfig/published/update`,
    removeVerifyWithConfig: `${prefix}/verifyWithConfig/published/remove`,
    // Operator assignment
    listBPMember: `${oauthAdminToolPrefix}/bpMember/published/list`,
    listBPOperator: `${oauthAdminToolPrefix}/bpOperator/published/list`,
    promoteBpOperator: `${oauthAdminToolPrefix}/bpOperator/published/promote`,
    downgradeBpOperator: `${oauthAdminToolPrefix}/bpOperator/published/downgrade`,
    listBpOperatorInService: `${oauthAdminToolPrefix}/bpOperator/published/listInService`,
    addNewBpOperatorToService: `${oauthAdminToolPrefix}/bpOperator/published/assign`,
    updateBpOperatorRoleInService: `${oauthAdminToolPrefix}/bpOperator/published/role`,
    removeBpOperatorFromService: `${oauthAdminToolPrefix}/bpOperator/published/remove`,
    listKYCService: `${oauthAdminToolPrefix}/operatorAssignment/published/listKyc`,
    listKYBService: `${oauthAdminToolPrefix}/operatorAssignment/published/listKyb`,
};
class AdminTool {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getListMarketplace(page = 0, limit = 10, sort) {
        const query = {
            page,
            limit,
            sort,
        };
        const url = `${API.listMarketplace}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async detailMarketplace(serviceId) {
        const url = `${API.detailMarketplace}?${qs_1.default.stringify({ serviceId })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateMarketplace(serviceId, payload) {
        const res = await this._httpClient.put(`${API.updateMarketplace}?serviceId=${serviceId}`, payload);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListNews(page = 0, limit = 10, sort) {
        const query = {
            page,
            limit,
            sort,
        };
        const url = `${API.listNews}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async createNews(newsData) {
        const res = await this._httpClient.post(API.createNews, {
            filter: {},
            inAppContent: '',
            pushContent: '',
            ...newsData,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result || null,
            entities: resBody.entities || {},
        };
    }
    async updateNews(newsId, updateData) {
        const url = `${API.updateNews}?${qs_1.default.stringify({ newsId })}`;
        const res = await this._httpClient.put(url, updateData);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListCertificates(page = 0, limit = 10, sort, query) {
        const url = `${API.listCertificates}?${qs_1.default.stringify({
            page,
            limit,
            sort,
            query,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async updateCertificateDisplayOrder(certificateId, displayOrder) {
        const url = `${API.updateCertificateDisplayOrder}?${qs_1.default.stringify({
            certificateId,
        })}`;
        const res = await this._httpClient.put(url, { displayOrder });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListIdentityField(page = 0, limit = 10, sort, query) {
        const url = `${API.listIdentity}?${qs_1.default.stringify({
            page,
            limit,
            sort,
            query,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async createIdentityField(identityData) {
        const res = await this._httpClient.post(API.createIdentity, identityData);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateIdentityField(identityId, updateData) {
        const url = `${API.updateIdentity}?${qs_1.default.stringify({ identityId })}`;
        const res = await this._httpClient.put(url, updateData);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListGroupIdentityField(page = 0, limit = 10, sort, query) {
        const url = `${API.listGroupIdentity}?${qs_1.default.stringify({
            page,
            limit,
            sort,
            query,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async createGroupIdentityField(groupIdentityData) {
        const res = await this._httpClient.post(API.createGroupIdentity, groupIdentityData);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateGroupIdentityField(groupId, updateData) {
        const url = `${API.updateGroupIdentity}?${qs_1.default.stringify({ groupId })}`;
        const res = await this._httpClient.put(url, updateData);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListRuntimeConfig(page = 0, limit = 10, query) {
        const url = `${API.listRuntimeConfig}?${qs_1.default.stringify({
            page,
            limit,
            query,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async getDetailRuntimeConfig(key) {
        const url = `${API.detailRuntimeConfig}?${qs_1.default.stringify({
            key,
        })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async createRuntimeConfig(runtimeConfigData) {
        const res = await this._httpClient.post(API.createRuntimeConfig, runtimeConfigData);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateRuntimeConfig(runtimeConfigId, updateData) {
        const url = `${API.updateRuntimeConfig}?${qs_1.default.stringify({
            runtimeConfigId,
        })}`;
        const res = await this._httpClient.put(url, updateData);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async queryUserDetailDebuggerTool(query) {
        const url = `${API.userDetail}?${qs_1.default.stringify({
            query,
        })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async queryTreeHistoryDebuggerTool(userId) {
        const url = `${API.treeHistory}?${qs_1.default.stringify({
            userId,
        })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async queryServiceRegisteredDebuggerTool(userId) {
        const url = `${API.serviceRegistered}?${qs_1.default.stringify({
            userId,
        })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async queryRegisterLogDebuggerTool(userId, serviceId, status) {
        const url = `${API.registerLog}?${qs_1.default.stringify({
            userId,
            serviceId,
            status,
        })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async querySubmitLogDebuggerTool(userId, serviceId, status, registerLog) {
        const url = `${API.submitLog}?${qs_1.default.stringify({
            userId,
            serviceId,
            status,
            registerLog,
        })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async queryUserCertificateDebuggerTool(userId, serviceId, status) {
        const url = `${API.userCertificate}?${qs_1.default.stringify({
            userId,
            serviceId,
            status,
        })}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async deleteIdentity(email, isDeleteWID, isDeleteCore, isDeleteAuth) {
        const res = await this._httpClient.post(API.deleteIdentity, {
            email,
            isDeleteWID,
            isDeleteCore,
            isDeleteAuth,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async deleteBulkIdentity(emailList) {
        const res = await this._httpClient.post(API.deleteBulkIdentity, {
            emailList,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListIdentityDeleted(page = 0, limit = 10, email) {
        const url = `${API.listIdentityDeleted}?${qs_1.default.stringify({
            page,
            limit,
            email,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async getListJobDeleteIdentity(page = 0, limit = 10) {
        const url = `${API.listJobDeleteIdentity}?${qs_1.default.stringify({
            page,
            limit,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async recoverIdentity(recordId) {
        const res = await this._httpClient.post(API.recoverIdentity, { recordId });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async deleteRecoverBin(recordId) {
        const res = await this._httpClient.post(API.deleteRecoverBin, { recordId });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListBillingStats(page = 0, limit = 10) {
        const url = `${API.listBillingStats}?${qs_1.default.stringify({
            page,
            limit,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async generateBillingStatsReport(startDate, endDate) {
        const url = `${API.generateReport}?${qs_1.default.stringify({
            startDate,
            endDate,
        })}`;
        const res = await this._httpClient.get(url, { responseType: 'blob' });
        return res.data;
    }
    async getBillingServiceLogs(page = 0, limit = 10, query) {
        const url = `${API.billingServiceLogs}?${qs_1.default.stringify({
            page,
            limit,
            query,
        })}`;
        const res = await this._httpClient.get(url);
        let resBody = lodash_1.default.get(res, 'data', null);
        if (resBody.statusCode !== 200) {
            const { statusCode, message } = resBody;
            throw new Errors_1.ServerError(statusCode, message);
        }
        const data = {
            result: null,
            entities: {},
        };
        resBody = resBody === null || resBody === void 0 ? void 0 : resBody.data;
        if (lodash_1.default.isEmpty(resBody)) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async checkCanUseClientIdToLink(clientId, serviceType) {
        const res = await this._httpClient.get(API.canUseClientIdToLink, {
            params: { clientId, serviceType },
        });
        let resBody = lodash_1.default.get(res, 'data.data', null);
        const data = {
            result: null,
            entities: {},
        };
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    // Deprecated
    async getListServiceLink(page = 0, limit = 10, query) {
        const res = await this._httpClient.get(API.getListServiceLink, {
            params: { page, limit, query },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    // Deprecated
    async getServiceLinkInfo(clientId) {
        const url = `${API.getServiceLinkInfo}?${qs_1.default.stringify({
            clientId,
        })}`;
        const res = await this._httpClient.get(url);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    // Deprecated
    async createServiceLink(serviceLinkData) {
        const res = await this._httpClient.post(API.createServiceLink, serviceLinkData);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    // Deprecated
    async updateServiceLink(linkId, updateLinkData) {
        const res = await this._httpClient.put(API.updateServiceLink, updateLinkData, { params: { linkId } });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return { result: null, entities: {} };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    // Deprecated
    async removeServiceLink(linkId) {
        const res = await this._httpClient.delete(API.removeServiceLink, {
            params: { linkId },
        });
        return {
            result: null,
            entities: {},
        };
    }
    async getListVerifyWithConfigs(page = 0, limit = 10, query) {
        const res = await this._httpClient.get(API.getListVerifyWithConfigs, {
            params: { page, limit, query },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (lodash_1.default.isEmpty(resBody)) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async getVerifyWithConfigInfo(clientId) {
        const res = await this._httpClient.get(API.getVerifyWithConfigInfo, {
            params: { clientId },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async createVerifyWithConfig(verifyWithConfigData) {
        const res = await this._httpClient.post(API.createVerifyWithConfig, verifyWithConfigData);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateVerifyWithConfig(linkId, updateLinkData) {
        const res = await this._httpClient.put(API.updateVerifyWithConfig, updateLinkData, { params: { linkId } });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return { result: null, entities: {} };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async removeVerifyWithConfig(linkId) {
        const res = await this._httpClient.delete(API.removeVerifyWithConfig, {
            params: { linkId },
        });
        return {
            result: null,
            entities: {},
        };
    }
    async getListBlockpassMember(email, page, limit) {
        const res = await this._httpClient.get(API.listBPMember, {
            params: { email, page, limit },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async getListBlockpassOperator(email, page, limit, omitClientId) {
        const res = await this._httpClient.get(API.listBPOperator, {
            params: { email, page, limit, omitClientId },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async promoteBlockpassOperator(userId) {
        const res = await this._httpClient.put(API.promoteBpOperator, {
            userId,
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return { result: null, entities: {} };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async downgradeBlockpassOperator(userId) {
        const res = await this._httpClient.put(API.downgradeBpOperator, {
            userId,
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return { result: null, entities: {} };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListBlockpassOperatorInService(clientId, page, limit) {
        const res = await this._httpClient.get(API.listBpOperatorInService, {
            params: { clientId, page, limit },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    async addNewBlockpassOperatorToService(newBPOperatorData) {
        const res = await this._httpClient.post(API.addNewBpOperatorToService, newBPOperatorData);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return { result: null, entities: {} };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateBpOperatorRoleInService(updateBpOperatorData) {
        const res = await this._httpClient.put(API.updateBpOperatorRoleInService, updateBpOperatorData);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return { result: null, entities: {} };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async removeBlockpassOperatorFromService(removeBPOperatorData) {
        const res = await this._httpClient.post(API.removeBpOperatorFromService, removeBPOperatorData);
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return { result: null, entities: {} };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async getListKYCServiceOperatorAssignmentTool(filter = {}, sort, page = 0, limit = 10) {
        const query = {
            filter,
            sort,
            page,
            limit,
        };
        const url = `${API.listKYCService}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, {});
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    /**
     * Function to get list service
     * @param filter - filter by name or client_id. Eg: {name:'dev',client_id:'dev}
     * @param sort - field and order to sort. Eg: {name: 'asc',createdAt:'asc'}
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service data
     */
    async getListKYBServiceOperatorAssignmentTool(filter = {}, sort, page = 0, limit = 10) {
        const query = {
            filter,
            sort,
            page,
            limit,
        };
        const url = `${API.listKYBService}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, {});
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
}
exports.default = AdminTool;
